import { Button, PlusSVG } from "@newsela/angelou";
import { actionNames, objectTypes, withTrackEvent } from "@newsela/snitch";

import { IStandard } from "@/search/Langston/types/IStandard";
import ReportGeneratedText from "@/view/ReportGeneratedText";
import { bottomActionsWrapperCss } from "./LessonPlanFooterActions.styles";

const ButtonWithTrackEvent = withTrackEvent(Button);

interface LessonPlanFooterActionsProps {
  contentId: string;
  extraData?:
    | {
        standards?: IStandard[];
        objective?: string;
      }
    | undefined;
  handleReset: () => void;
}

const LessonPlanFooterActions = ({
  contentId,
  extraData,
  handleReset,
}: LessonPlanFooterActionsProps) => {
  return (
    <div css={bottomActionsWrapperCss}>
      <ReportGeneratedText
        contentId={contentId}
        reportSource="LessonPlanner"
        extraData={
          extraData && (extraData.standards || extraData.objective)
            ? {
                ...(extraData.standards && {
                  standards: extraData.standards.map((s) => s.name),
                }),
                ...(extraData.objective && {
                  objective: extraData.objective,
                }),
              }
            : undefined
        }
      />
      <ButtonWithTrackEvent
        dataProps={{ "data-qa-selector": "new-lesson-button" }}
        flavor={Button.flavors.primary}
        icon={{
          SvgComponent: PlusSVG,
          alignment: Button.iconAlignments.right,
        }}
        actionName={actionNames.cancel}
        objectType={objectTypes.generatedTextAsset}
        streamProperties={{
          description: "User clicked to start a new lesson plan",
        }}
        onClick={handleReset}
      >
        New Lesson
      </ButtonWithTrackEvent>
    </div>
  );
};

export default LessonPlanFooterActions;
